import { providerAuthClient } from '@/http/client';
import { LoginUserRequestBody, LoginUserResponseBody } from 'bff';

export const loginUser = (
  data: LoginUserRequestBody,
): Promise<LoginUserResponseBody> =>
  providerAuthClient.post(data, '/v1/auth/login').json();
